export default {"src":"/_next/static/media/cards-icon-8.7a1ad3e5.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};